app.service('dynamicBreadcrumbs',
  ['SETTINGS', '$location', '$window', 'authHelper', '$ngConfirm', 'apiHelper', 'HttpAuth',
    '$rootScope', '$filter', '$timeout', '$anchorScroll', 'CONSTANTS', 'defaultBreadcrumbs',
    function (SETTINGS, $location, $window, authHelper, $ngConfirm, apiHelper, HttpAuth,
      $rootScope, $filter, $timeout, $anchorScroll, CONSTANTS, defaultBreadcrumbs) {

      const dynamicBreadcrumbsService = this;
      let dynamicCrumbs = [];

      dynamicBreadcrumbsService.getPrevPath = function () {
        if (dynamicCrumbs.length >= 2) {
          const url = dynamicCrumbs[dynamicCrumbs.length - 2][1];
          if (url) {
            return url.replace('#', '');
          }
        }
      };

      /*
        This method resets breadcrumbs to default
      */
      dynamicBreadcrumbsService.getDefault = function (start, extra_url_lookup, extra_text_lookup) {
        return dynamicBreadcrumbsService.get(start, extra_url_lookup, extra_text_lookup, true);
      };

      /*
        This method appends item to breadcrumbs
      */
      dynamicBreadcrumbsService.get = function (start, extra_url_lookup, extra_text_lookup, reset_to_default) {
        const defaultCrumbs = defaultBreadcrumbs.getBreadcrumb(start,
          extra_url_lookup,
          extra_text_lookup);

        if (!defaultCrumbs) {
          return;
        }

        if (!dynamicCrumbs || !dynamicCrumbs.length || reset_to_default) {
          dynamicCrumbs = defaultCrumbs;

          // Check if a specific URL has been passed for any of the mid-links
          if (extra_url_lookup != null && !$.isEmptyObject(extra_url_lookup)) {
            for (let i = 0; i < dynamicCrumbs.length; i++) {
              for (const urlKey in extra_url_lookup) {
                if (dynamicCrumbs[i][0].toLowerCase() === urlKey.toLowerCase()) {
                  dynamicCrumbs[i][1] = extra_url_lookup[urlKey];
                }
              }
            }
          }

          return dynamicCrumbs;
        }

        const cur_text = defaultCrumbs[defaultCrumbs.length - 1][0];
        const cur_url = defaultCrumbs[defaultCrumbs.length - 1][1];

        // do not append to this text, replace it instead
        const excludeText = 'Welcome to Genesis Research Group';

        // search text in dynamicCrumbs and if found, trim array up to that point
        let cur_text_index = -1;

        for (let i = 0; i < dynamicCrumbs.length; i++) {
          if (dynamicCrumbs[i][0] === cur_text || dynamicCrumbs[i][1] === cur_url) {
            cur_text_index = i;
            break;
          }

          if (dynamicCrumbs[i][0] === excludeText) {
            cur_text_index = i;
            break;
          }
        }

        if (cur_text_index !== -1) {
          // trim array
          dynamicCrumbs = dynamicCrumbs.slice(0, cur_text_index + 1);
          // update last text and url (in case they change)
          dynamicCrumbs[dynamicCrumbs.length - 1][0] = cur_text;
          dynamicCrumbs[dynamicCrumbs.length - 1][1] = cur_url;
        } else {
          // append to array
          dynamicCrumbs.push(defaultCrumbs[defaultCrumbs.length - 1]);
        }

        return dynamicCrumbs;
      };
    }]
);
